function isObject(value) {
  return value && typeof value === 'object' && !Array.isArray(value);
}

export function mergeDeep(base, override) {
  if (!isObject(base)) return isObject(override) ? override : base;
  const out = { ...base };
  Object.keys(override || {}).forEach((key) => {
    const baseValue = base[key];
    const overrideValue = override[key];
    if (isObject(baseValue) && isObject(overrideValue)) {
      out[key] = mergeDeep(baseValue, overrideValue);
    } else {
      out[key] = overrideValue;
    }
  });
  return out;
}
